// extracted by mini-css-extract-plugin
export default {"fun":"Fun_fun__Aq2xM"};